import { useNavigate } from "react-router-dom";
import "./notfound.scss";

export default function NotFound() {
  const navigate = useNavigate();

  // ============================================================
  // FECHAR A ABA
  // ============================================================
  //
  // Como os relatórios são abertos com target="_blank",
  // tentamos fechar somente a aba atual.
  //
  // Se o navegador impedir o window.close(),
  // fazemos fallback para /maps.
  // ============================================================

  const fecharPagina = () => {
    window.close();

    // Alguns navegadores bloqueiam window.close()
    // caso a aba não tenha sido aberta via JavaScript.
    setTimeout(() => {
      navigate("/maps", { replace: true });
    }, 150);
  };

  return (
    <div className="notfound-container">

      {/* ======================================================
          EFEITOS DE FUNDO
      ====================================================== */}

      <div className="notfound-grid" />
      <div className="notfound-glow" />


      {/* ======================================================
          CARD
      ====================================================== */}

      <div className="notfound-card">

        {/* Linha superior */}

        <div className="notfound-top-line" />


        {/* ====================================================
            ÍCONE
        ==================================================== */}

        <div className="notfound-icon">
          <span>!</span>
        </div>


        {/* ====================================================
            CÓDIGO
        ==================================================== */}

        <div
          className="notfound-code"
          data-text="404"
        >
          404
        </div>


        {/* ====================================================
            TÍTULO
        ==================================================== */}

        <h1>
          Página não encontrada
        </h1>


        {/* ====================================================
            DESCRIÇÃO
        ==================================================== */}

        <p>
          A rota que você tentou acessar não está disponível
          ou ainda não foi configurada no sistema.
        </p>


        {/* ====================================================
            STATUS
        ==================================================== */}

        <div className="notfound-status">

          <span className="status-dot" />

          <span>
            Rota inválida
          </span>

        </div>


        {/* ====================================================
            BOTÃO
        ==================================================== */}

        <button
          type="button"
          onClick={fecharPagina}
          className="notfound-button"
        >
          <span className="button-icon">×</span>

          Fechar página
        </button>

      </div>

    </div>
  );
}